export class Brand {
  constructor(
    public name: string,
    public slug: string,
  ) {}
}
